import C54_ProfilePhotoLinkBox from "@components/C54_ProfilePhotoLinkBox/C54_ProfilePhotoLinkBox";
import Grid from "@components/Grid/Grid";
import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";
import { ContentfulImage } from "@customTypes/ContentfulImage";
import { TinyMceRichText } from "@customTypes/TinyMceRichText";
import { getContentfullImagePath } from "@utilities/getContentfullImagePath";
import RenderComponents from "@utilities/renderComponents";
import { FacultyProfileData } from "context/facultyDetails";
import Head from "next/head";
import { ReactNode } from "react";
import {
  ContributorDetailContextProps,
  ContributorDetailProvider,
} from "../../../context/contributorDetails";
import styles from "./ContributorProfileDetail.module.scss";

export interface ContributorProfileDetailProps
  extends ContributorDetailContextProps {
  slug?: string;
  bodyContent?: ReactNode;
  detailContent?: ReactNode;
  profileBoxContent?: ReactNode;
  contentTinyMce?: TinyMceRichText;
  profilePhoto?: ContentfulImage;
  facultyProfileData?: FacultyProfileData;
}

export const ContributorProfileDetail = (props: {
  content: ContributorProfileDetailProps;
}) => {
  const { content } = props;
  const { bodyContent, detailContent, profileBoxContent, ...details } = content;
  const {
    profileFirstname,
    profileSurname,
    profilePositionTitle,
    profilePhoto,
  } = details;

  const title =
    content?.facultyProfileData?.fields.profilePositionTitle ||
    profilePositionTitle;

  const url = profilePhoto?.fields?.file?.url
    ? `${profilePhoto?.fields?.file?.url}?q=70&w=512&h=386`
    : "";

  return (
    <ContributorDetailProvider details={details}>
      <Head>
        <meta
          name="profilephotosmallurl"
          content={getContentfullImagePath(url)}
        />
        <meta
          name="profilephotosmallalt"
          content={profilePhoto?.fields.title || ""}
        />

        <meta name="profilepositiontitle" content={title || ""} />

        <meta name="profilesurname" content={profileSurname || ""} />
      </Head>
      <div className="outer-wrap">
        <div className="wrapper">
          <Grid row justify="space-between">
            <Grid column sm={12} md={8}>
              <h1 className={styles.h2}>
                {profileFirstname} {profileSurname}
              </h1>
              <h5 className={styles["contributor-details__p"]}>{title}</h5>
              <h5 className={styles["contributor-details__role"]}>
                {content?.facultyProfileData?.fields.profileQualification}
              </h5>

              <RichTextDisplay
                richText={content?.profileDetailsText}
                tinyMceRichText={content?.contentTinyMce}
                richTextStyles
              />
              {RenderComponents(detailContent)}
            </Grid>
            <Grid column sm={12} md={4} lg={3} customClass="tp4">
              <C54_ProfilePhotoLinkBox
                // @ts-expect-error type mistmatch
                content={{ ...details, ...details.contributorProfileData }}
              />
              {RenderComponents(profileBoxContent)}
            </Grid>
          </Grid>
        </div>
      </div>
      {RenderComponents(bodyContent)}
    </ContributorDetailProvider>
  );
};

export default ContributorProfileDetail;
